export enum GuestUserStatus {
  IsGuestUser = "Is guest user",
  IsNormalUser = "Is normal user"
}
